import { createAction } from "@ngrx/store";

export const searchToolboxTalks = createAction(
  "[ToolboxTalk API] Toolbox Talks Search"
);
